import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MaskLines } from "@/components/motion";

export const PageHero = ({ eyebrow, lines, intro, img, imgAlt, tone = "light", children, testid }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);
  const dark = tone === "dark";
  const cream = tone === "cream";
  return (
    <section ref={ref} data-testid={testid}
      className={`relative overflow-hidden pt-28 sm:pt-36 pb-16 sm:pb-24 ${dark ? "bg-[var(--leaf-deep)] text-white" : cream ? "bg-[var(--cream)]" : "bg-[var(--paper)]"}`}>
      <div className="mx-auto grid max-w-[1400px] items-end gap-10 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }} className={`eyebrow ${dark ? "!text-[#9be0b0]" : cream ? "!text-[var(--forest)]" : ""}`}>{eyebrow}</motion.p>
          <MaskLines lines={lines} className={`mt-5 font-display text-[2.6rem] leading-[0.95] sm:text-6xl lg:text-7xl xl:text-[5.5rem] font-black tracking-tight ${cream ? "text-[var(--forest)]" : dark ? "" : "text-[var(--leaf)]"}`} />
          {intro && (
            <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6, duration: 0.8 }}
              className={`mt-7 max-w-xl text-base sm:text-lg leading-relaxed ${dark ? "text-white/85" : "text-[var(--muted-ink)]"}`}>{intro}</motion.p>
          )}
          {children}
        </div>
        {img && (
          <motion.div initial={{ clipPath: "inset(100% 0 0 0)" }} animate={{ clipPath: "inset(0% 0 0 0)" }} transition={{ duration: 1.3, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
            className="lg:col-span-5 relative aspect-[4/5] max-h-[560px] w-full overflow-hidden arch">
            <motion.img style={{ y }} src={img} alt={imgAlt} className="absolute inset-0 h-[118%] w-full scale-110 object-cover" />
          </motion.div>
        )}
      </div>
    </section>
  );
};
